import { Component, OnInit } from '@angular/core';
import { CellRenderer } from '@shared/interfaces/table/cell-renderer';
import { DecimalPipe } from '@angular/common';

@Component({
  selector: 'app-decimal-cell',
  imports: [
    DecimalPipe,
  ],
  templateUrl: './decimal-cell.component.html',
  styleUrl: './decimal-cell.component.css'
})
export class DecimalCellComponent extends CellRenderer implements OnInit {

  public decimals: number = 2;
  public hideIfUndefined: boolean = false;

  public ngOnInit(): void {
    if (this.params?.cellRendererParams?.decimals) {
      this.decimals = this.params.cellRendererParams.decimals;
    }

    if (this.params?.cellRendererParams?.hideIfUndefined) {
      this.hideIfUndefined = this.params.cellRendererParams.hideIfUndefined;
    }

    this.value = this.data[this.params['key']];
  }

}
